import appLinks from '../appLinks/config.json';
import url from './url';

const clean = (value, limit = 240) => Array.from(String(value || '')
  // Explicitly strip control characters from text passed to other applications.
  // eslint-disable-next-line no-control-regex
  .replace(/[\u0000-\u001f\u007f\u200b-\u200f\u202a-\u202e\u2066-\u2069\ufeff]/g, ' ')
  .replace(/\s+/g, ' ').trim()).slice(0, limit).join('');

// The current card owns the share target, independently of feed/profile routes,
// votes in progress and native localhost URLs. No network call before the tap.
export function postShare(reaction) {
  const restricted = reaction.privat || reaction.is_hidden || reaction.is_banned
    || ['text_status', 'overall_status'].some(key => reaction[key] === 'banned');
  // A rejected attachment does not hide the author's allowed text. Share only
  // public identity/title here; no raw body, attachment URLs or moderation data.
  const user = reaction.user || {};
  const name = clean([user.first_name, user.last_name].filter(Boolean).join(' '), 120);
  const handle = clean(user.user_name, 100);
  const author = [name, handle && `@${handle}`].filter(Boolean).join(' ');
  const title = restricted ? 'WIW' : clean(reaction.story?.title) || 'WIW';
  return {
    shareTitle: title,
    shareText: restricted ? 'WIW' : [author && `${author} · WIW`, title].filter(Boolean).join('\n'),
    shareUrl: new URL(url(`/opinion/${reaction.id}`), appLinks.origin).href,
    shareContext: { source: 'content', targetType: 'opinion', targetId: reaction.id },
  };
}
